import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WifiProtectedSetupIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wifi_protected_setup"}/>
}
